import './Page.css';

import { useState } from 'react';
import { useHistory } from 'react-router-dom';

import Bell from '../../assets/images/icons/bell.png';
// images
import IconSearch from '../../assets/images/icons/search_rv.png';
import IconUser from '../../assets/images/icons/user_rv.png';
import Campaign from '../../views/components/Campaign/Campaign';
import Footer from '../../views/components/Footer/Footer';
import SearchProducts from '../../views/components/SearchProducts';
import { ReactComponent as BottomArrow } from './../../assets/svg/bottom-arrow.svg';
import { ReactComponent as CarfilloIcon } from './../../assets/svg/carfillo-logo.svg';
import { ReactComponent as CartIcon } from './../../assets/svg/cart.svg';
import { ReactComponent as SearchIcon } from './../../assets/svg/search.svg';

const Page = ({
  children,
  className,
  mobileContainer,
  hasHeader,
  noHeader,
  activeCategory,
  logo,
  headerFix,
  footer,
  showFooter,
  mobileMode,
  bell,
  cart,
  user,
  header_back_title,
  address,
  goback,
  back,
  drawer,
  category,
  no_header_center_label,
  title,
  search
}) => {
  const history = useHistory();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const root_classes = [];
  if (className) {
    root_classes.push(className, 'helbest-page-container');
  } else {
    root_classes.push('helbest-page-container');
  }
  if (mobileContainer) {
    root_classes.push('mobile-container');
  }

  return (
    <div className={root_classes.join(' ')}>
      <div className="fixed-header-wrapper">
        {hasHeader ? <Campaign activeCategory={activeCategory} /> : null}
        {noHeader ? null : (
          <header className={`helbest-page-header ${headerFix ? 'fix-top' : ''}`}>
            <div className="helbest-page-header-left">
              {logo ? (
                logo === true ? (
                  <div className="helbest-page-header-logo" onClick={() => history.push('/')}>
                    <CarfilloIcon className="page-header-icon" />
                  </div>
                ) : (
                  <div className="helbest-page-header-logo">
                    <img alt="CarFillo" src={logo} />
                  </div>
                )
              ) : null}
              {search ? (
                <div className="helbest-page-header-search">
                  <img alt="جستجو" className="hei-20" src={IconSearch} />
                </div>
              ) : null}
            </div>
            <div className="helbest-page-header-mid">
              {!!title && !no_header_center_label ? (
                <div className="helbest-page-header-title">{title}</div>
              ) : null}
              {category ? <div className="category_shower">category</div> : null}
            </div>
            <div className="helbest-page-header-right">
              {drawer}
              {back ? (
                <div
                  className="helbest-page-header-back"
                  onClick={() => (goback ? history.goBack() : history.push(address))}>
                  <BottomArrow className="helbest-page-header-back-icon" />
                  <span>{header_back_title || ''}</span>
                </div>
              ) : null}
              {user ? (
                <div className="helbest-page-header-user helbest-page-header-search">
                  <img alt="کاربر" className="hei-20" src={IconUser} />
                </div>
              ) : null}
              {cart ? (
                <div
                  className="helbest-page-header-user helbest-page-header-search"
                  onClick={() => history.push('/cart/')}>
                  <CartIcon className="page-cart-icon" />
                </div>
              ) : null}
              <div className="helbest-page-header-search" onClick={showModal}>
                <SearchIcon className="page-search-icon" />
              </div>

              {document.getElementById('najva-bell-image-wrapper') && bell ? (
                <button
                  className="bell-icon"
                  onClick={() => document.getElementById('najva-bell-image-wrapper').click()}
                  type="button">
                  <img alt="bell-icon" src={Bell} />
                </button>
              ) : null}
            </div>
          </header>
        )}
      </div>
      <section className={mobileMode ? 'helbest-mobile-mode' : 'helbest-desktop-page-body-wraper'}>
        <div className={`helbest-page-body ${mobileContainer ? 'mobile-container' : ''}`}>
          {category ? <div className="category" /> : null}
          {children}
        </div>
      </section>
      {showFooter ? (
        <>
          {footer ? (
            <>
              <div className="fix-footer" />
              {footer}
            </>
          ) : null}
          {!footer ? (
            <>
              <div className="helbest-fix-footer" />
              <footer className="helbest-page-footer">
                <Footer />
              </footer>
            </>
          ) : null}
        </>
      ) : null}

      <SearchProducts isModalVisible={isModalVisible} setIsModalVisible={setIsModalVisible} />
    </div>
  );
};

export default Page;
